import definitions from "../../../definitions";
import ItemAcorn from "./ItemAcorn";
import ItemBlueFlowers from "./ItemBlueFlowers";
import ItemCenticoreTear from "./ItemCenticoreTear";
import ItemCleaningCloth from "./ItemCleaningCloth";
import ItemCleaningFluid from "./ItemCleaningFluid";
import ItemCollectionJarBlueFlowersEmpty from "./ItemCollectionJarBlueFlowersEmpty";
import ItemCollectionJarBlueFlowersFull from "./ItemCollectionJarBlueFlowersFull";
import ItemDaisyFlowers from "./ItemDaisyFlowers";
import ItemEmptyMug from "./ItemEmptyMug";
import ItemHealthTurnip from "./ItemHealthTurnip";
import ItemMop from "./ItemMop";
import ItemScentedSoap from "./ItemScentedSoap";
import ItemSlugBroth from "./ItemSlugBroth";
import ItemSocks from "./ItemSocks";
import ItemTreasure from "./ItemTreasure";
import ItemTruffleOil from "./ItemTruffleOil";
import ItemUnknown from "./ItemUnknown";
import ItemUselessGlasses from "./ItemUselessGlasses";
import ItemVialCenticoreTearsEmpty from "./ItemVialCenticoreTearsEmpty";
import ItemVialCenticoreTearsFull from "./ItemVialCenticoreTearsFull";
import ItemBlackSpottedMushroom from "./ItemBlackSpottedMushroom";
import ItemRoyalCloak from "./ItemRoyalCloak";
import ItemSongSheet from "./ItemSongSheet";
import ItemCollectionJarTurnipTops from "./ItemCollectionJarTurnipTopsFull";
import ItemTrousers from "./ItemTrousers";
import ItemCornSeeds from "./ItemCornSeeds";
import ItemPrizedCorn from "./ItemPrizedCorn";
import ItemCourgetteSeeds from "./ItemCourgetteSeeds";
import ItemPrizedCourgette from "./ItemPrizedCourgette";
import ItemPrizedBeetroot from "./ItemPrizedBeetroot";
import ItemBeetrootSeeds from "./ItemBeetrootSeeds";
import ItemSalad from "./ItemSalad";
import ItemTurnipSeeds from "./ItemTurnipSeeds";
import ItemBucket from "./ItemBucket";
import ItemCollectionJarTrufflesFull from "./ItemCollectionJarTrufflesFull";
import ItemTruffle from "./ItemTruffle";
import ItemPrizedTurnip from "./ItemPrizedTurnip";
import ItemTurnipCubes from "./ItemTurnipCubes";
import ItemPinkFlowers from "./ItemPearls";
import ItemRoyalMirror from "./ItemRoyalMirror";
import ItemTurnipTop from "./ItemTurnipTop";
import ItemBrassBell from "./ItemBrassBell";
import ItemCollectionJarSpottedMushroomsFull from "./ItemCollectionJarSpottedMushroomsFull";
import ItemTeaCup from "./ItemTeaCup";
import ItemGoldenTurnip from "./ItemGoldenTurnip";
import ItemBow from "./ItemBow";
import ItemDamselDress from "./ItemDamselDress";
import ItemGoldenCoin from "./ItemGoldenButton";
import ItemMassageOil from "./ItemMassageOil";
import ItemPeanuts from "./ItemPeanuts";
import ItemPearls from "./ItemPearls";
import ItemCollectionJarPearls from "./ItemCollectionJarPearls";
import ItemCollectionJarTrufflesEmpty from "./ItemCollectionJarTrufflesEmpty";
import ItemTruffleTower from "./ItemTruffleTower";
import ItemGoldenButton from "./ItemGoldenButton";
import ItemHatBell from "./ItemHatBell";

export default class ItemFactory {
    /**
     * @param {string} id
     * @param {Object} properties
     * @returns {Item}
     */
    static create(id, properties) {
        switch (id) {
            case definitions.ITEM_ID.ACORN: {
                return new ItemAcorn(properties);
            }
            case definitions.ITEM_ID.BUCKET: {
                return new ItemBucket();
            }
            case definitions.ITEM_ID.BLUE_FLOWERS: {
                return new ItemBlueFlowers();
            }
            case definitions.ITEM_ID.BLACK_SPOTTED_MUSHROOMS: {
                return new ItemBlackSpottedMushroom();
            }
            case definitions.ITEM_ID.BEETROOT_SEEDS: {
                return new ItemBeetrootSeeds();
            }
            case definitions.ITEM_ID.BRASS_BELL: {
                return new ItemBrassBell();
            }
            case definitions.ITEM_ID.COURGETTE_SEEDS: {
                return new ItemCourgetteSeeds();
            }
            case definitions.ITEM_ID.CORN_SEEDS: {
                return new ItemCornSeeds();
            }
            case definitions.ITEM_ID.CLEANING_CLOTH: {
                return new ItemCleaningCloth();
            }
            case definitions.ITEM_ID.CLEANING_FLUID: {
                return new ItemCleaningFluid();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_TRUFFLES_FULL: {
                return new ItemCollectionJarTrufflesFull();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_BLUE_FLOWERS_EMPTY: {
                return new ItemCollectionJarBlueFlowersEmpty();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_BLUE_FLOWERS_FULL: {
                return new ItemCollectionJarBlueFlowersFull();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_TURNIP_TOPS_FULL: {
                return new ItemCollectionJarTurnipTops();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_TRUFFLES_EMPTY: {
                return new ItemCollectionJarTrufflesEmpty();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_BLACK_SPOTTED_MUSHROOMS_FULL: {
                return new ItemCollectionJarSpottedMushroomsFull();
            }
            case definitions.ITEM_ID.COLLECTION_JAR_PEARLS_FULL: {
                return new ItemCollectionJarPearls();
            }
            case definitions.ITEM_ID.DAISY_FLOWERS: {
                return new ItemDaisyFlowers();
            }
            case definitions.ITEM_ID.DAMSEL_DRESS: {
                return new ItemDamselDress();
            }
            case definitions.ITEM_ID.EMPTY_MUG_1: {
                return new ItemEmptyMug(definitions.ITEM_ID.EMPTY_MUG_1);
            }
            case definitions.ITEM_ID.EMPTY_MUG_2: {
                return new ItemEmptyMug(definitions.ITEM_ID.EMPTY_MUG_2);
            }
            case definitions.ITEM_ID.EMPTY_MUG_3: {
                return new ItemEmptyMug(definitions.ITEM_ID.EMPTY_MUG_3);
            }
            case definitions.ITEM_ID.GOLDEN_TURNIP: {
                return new ItemGoldenTurnip(properties);
            }
            case definitions.ITEM_ID.GOLDEN_BUTTON: {
                return new ItemGoldenButton();
            }
            case definitions.ITEM_ID.HEALTH_TURNIP: {
                return new ItemHealthTurnip();
            }
            case definitions.ITEM_ID.HAT_BELL: {
                return new ItemHatBell();
            }
            case definitions.ITEM_ID.ROYAL_CLOAK: {
                return new ItemRoyalCloak();
            }
            case definitions.ITEM_ID.ROYAL_SVAN_MIRROR: {
                return new ItemRoyalMirror();
            }
            case definitions.ITEM_ID.MOP: {
                return new ItemMop();
            }
            case definitions.ITEM_ID.MASSAGE_OIL: {
                return new ItemMassageOil();
            }
            case definitions.ITEM_ID.PRIZED_CORN: {
                return new ItemPrizedCorn();
            }
            case definitions.ITEM_ID.PRIZED_COURGETTE: {
                return new ItemPrizedCourgette();
            }
            case definitions.ITEM_ID.PRIZED_BEETROOT: {
                return new ItemPrizedBeetroot();
            }
            case definitions.ITEM_ID.PRIZED_TURNIP: {
                return new ItemPrizedTurnip();
            }
            case definitions.ITEM_ID.PEARLS: {
                return new ItemPearls();
            }
            case definitions.ITEM_ID.PEANUTS: {
                return new ItemPeanuts();
            }
            case definitions.ITEM_ID.PRINCE_SVANS_TROUSERS: {
                return new ItemTrousers();
            }
            case definitions.ITEM_ID.BOW: {
                return new ItemBow();
            }
            case definitions.ITEM_ID.SCENTED_SOAP: {
                return new ItemScentedSoap();
            }
            case definitions.ITEM_ID.SLUG_BROTH: {
                return new ItemSlugBroth();
            }
            case definitions.ITEM_ID.SOCKS: {
                return new ItemSocks();
            }
            case definitions.ITEM_ID.SONG_SHEET: {
                return new ItemSongSheet();
            }
            case definitions.ITEM_ID.SALAD: {
                return new ItemSalad();
            }
            case definitions.ITEM_ID.TREASURE: {
                return new ItemTreasure(properties);
            }
            case definitions.ITEM_ID.TRUFFLE_TOWER: {
                return new ItemTruffleTower();
            }
            case definitions.ITEM_ID.TRUFFLE_OIL: {
                return new ItemTruffleOil();
            }
            case definitions.ITEM_ID.TRUFFLE: {
                return new ItemTruffle();
            }
            case definitions.ITEM_ID.TURNIP_CUBES: {
                return new ItemTurnipCubes();
            }
            case definitions.ITEM_ID.TURNIP_TOP: {
                return new ItemTurnipTop();
            }
            case definitions.ITEM_ID.TURNIP_SEEDS: {
                return new ItemTurnipSeeds();
            }
            case definitions.ITEM_ID.TEA_CUP: {
                return new ItemTeaCup();
            }
            case definitions.ITEM_ID.USELESS_GLASSES: {
                return new ItemUselessGlasses();
            }
            case definitions.ITEM_ID.VIAL_CENTICORE_TEARS_EMPTY: {
                return new ItemVialCenticoreTearsEmpty();
            }
            case definitions.ITEM_ID.VIAL_CENTICORE_TEARS_FULL: {
                return new ItemVialCenticoreTearsFull();
            }
            default: {
                return new ItemUnknown(id);
            }
        }
    }
}